import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ChipsArray from './ChipsArray';
import ClientProvider from './client';
export default createDemo(import.meta.url, ChipsArray, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/chips/demos/array/ChipsArray.tsx",
    "fileName": "ChipsArray.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { styled } from '@mui/material/styles';\nimport Chip from '@mui/material/Chip';\nimport Paper from '@mui/material/Paper';\nimport TagFacesIcon from '@mui/icons-material/TagFaces';\n\ninterface ChipData {\n  key: number;\n  label: string;\n}\n\nconst ListItem = styled('li')(({ theme }) => ({\n  margin: theme.spacing(0.5),\n}));\n\nexport default function ChipsArray() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [chipData, setChipData] = React.useState<readonly ChipData[]>([\n    { key: 0, label: 'Angular' },\n    { key: 1, label: 'jQuery' },\n    { key: 2, label: 'Polymer' },\n    { key: 3, label: 'React' },\n    { key: 4, label: 'Vue.js' },\n  ]);\n\n  const handleDelete = (chipToDelete: ChipData) => () => {\n    setChipData((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));\n  };\n\n  return (\n    <Paper\n      sx={{\n        display: 'flex',\n        justifyContent: 'center',\n        flexWrap: 'wrap',\n        listStyle: 'none',\n        p: 0.5,\n        m: 0,\n      }}\n      component=\"ul\"\n    >\n      {chipData.map((data) => {\n        let icon;\n\n        if (data.label === 'React') {\n          icon = <TagFacesIcon />;\n        }\n\n        return (\n          <ListItem key={data.key}>\n            <Chip\n              icon={icon}\n              label={data.label}\n              onDelete={data.label === 'React' ? undefined : handleDelete(data)}\n            />\n          </ListItem>\n        );\n      })}\n    </Paper>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 60,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { styled } from '@mui/material/styles';\nimport Chip from '@mui/material/Chip';\nimport Paper from '@mui/material/Paper';\nimport TagFacesIcon from '@mui/icons-material/TagFaces';\n\ninterface ChipData {\n  key: number;\n  label: string;\n}\n\nconst ListItem = styled('li')(({ theme }) => ({\n  margin: theme.spacing(0.5),\n}));\n\nexport default function ChipsArray() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [chipData, setChipData] = React.useState<readonly ChipData[]>([\n    { key: 0, label: 'Angular' },\n    { key: 1, label: 'jQuery' },\n    { key: 2, label: 'Polymer' },\n    { key: 3, label: 'React' },\n    { key: 4, label: 'Vue.js' },\n  ]);\n\n  const handleDelete = (chipToDelete: ChipData) => () => {\n    setChipData((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));\n  };\n\n  return (\n    <Paper\n      sx={{\n        display: 'flex',\n        justifyContent: 'center',\n        flexWrap: 'wrap',\n        listStyle: 'none',\n        p: 0.5,\n        m: 0,\n      }}\n      component=\"ul\"\n    >\n      {chipData.map((data) => {\n        let icon;\n\n        if (data.label === 'React') {\n          icon = <TagFacesIcon />;\n        }\n\n        return (\n          <ListItem key={data.key}>\n            <Chip\n              icon={icon}\n              label={data.label}\n              onDelete={data.label === 'React' ? undefined : handleDelete(data)}\n            />\n          </ListItem>\n        );\n      })}\n    </Paper>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 60,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/styles",
      "@mui/material/Chip",
      "@mui/material/Paper",
      "@mui/icons-material/TagFaces"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
